<template>
  <a-card title="素材列表">
    <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
      <a-form-item>
        <a-input :allowClear="true" placeholder="PackageID" v-model:value="formSearch.package_id" />
      </a-form-item>
      <a-form-item>
        <a-input :allowClear="true" placeholder="名称" v-model:value="formSearch.name" />
      </a-form-item>
      <a-form-item  label="任务类型"  name="style_id">
        <a-select
          :allowClear="true"
          style="width: 100px;"
          v-model:value="formSearch.style_id"
          :options="TaskStyleGroupOptions"
        />
      </a-form-item>
      <a-form-item>
        <a-space>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
          <a-button v-if="formSearch.package_id > 0" type="primary" @click="handleResourceUpload()">修改素材</a-button>
        </a-space>
      </a-form-item>
     
    </a-form>
  
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
    <a-table 
      class="ant-table-striped"
      show-quick-jumper
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
    >
      <template #operator_id="{ record }">
        <Username :user_id="record.operator_id" />
      </template>
      <template #content="{ record }">
        <div v-if="record.resource_type === 'prompt'">
          {{ record.content }}
        </div>
        <div v-else-if="record.resource_type === 'refer_image'">
          <a-image :preview="{src: rawImage(record.image_key)}" :src="thumbnail(record.image_key)" alt="refer_image" style="max-width: 100px; max-height: 100px;" />
        </div>
      </template>
    </a-table>
  </a-card>

</template>
<script>
import { defineComponent,  h,onMounted} from 'vue'
import { Modal, message } from 'ant-design-vue';

import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import { useStore } from 'vuex'
import {useRoute} from 'vue-router'
import { TaskStyleGroupOptions, SubTypeOptions ,StyleNames, ToolIDOptions} from '@/utils/macro'
import { thumbnail, rawImage } from '@/utils/image'
import Username from '@/components/Username.vue';

export default defineComponent({
  components: {
    SearchOutlined,
    Username,
  },
  data(){
    return {
      loading: false,
      dataSource: [],
      pageNo: 0,
      StyleNames,
      TaskStyleGroupOptions,
      labelCategoryOptions: [
        {
          label: "Prompt", value: 'prompt'
        }, {
          label: "refer_image", value: 'refer_image'
        },
      ],
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-quick-jumper': true,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '性能问题，总条数不再展示',

       formSearch: {
        style_id: '',
        name: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    const route = useRoute()
    if (route.query['package_id']) {
      this.formSearch.package_id = route.query['package_id']
    }

    this.handleTableChange()
  },
  computed:{
  },
  methods: {
    handleResourceUpload(){
      this.$router.push({
        path: '/home/testcase/packages/resources/upload',
        query: {
          package_id: this.formSearch.package_id,
        }
      })
    },
    thumbnail,rawImage,
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
     
      let limit = pagi.pageSize
      let orderBy = "id desc"
      let offset =  (pagi.current - 1) * pagi.pageSize
      const rsp = await request.get(`/api/testcase/packages/${this.formSearch.package_id}/resources`, {
        offset: offset,
        limit: limit,
        order_by: orderBy,
        ...this.formSearch,
        // after_cursor: afterCursor,
        // before_cursor: beforeCursor,
      })
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      
      for(let item of this.dataSource) {
        item.created_at = new Date(item.created_at).toLocaleString()
        item.updated_at = new Date(item.updated_at).toLocaleString()
      }
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`

      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
    
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width:80,
        },
        {
          title: '名称',
          dataIndex: 'name',
          key: 'name',
          width:200,
        },
        {
          title: '内容',
          dataIndex: 'content',
          key: 'content',
          slots: { customRender: 'content' },
        },{
          title: '素材类型',
          dataIndex: 'resource_type',
          key: 'resource_type',
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          // slots: { customRender: 'created_at' },
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          key: 'operator',
          slots: { customRender: 'operator_id' },
        },
         {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.thumbnail-wraps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.prompt-container {
  cursor: pointer;
  max-height: 350px;
  max-width: 100px;
  overflow-y: scroll;
}
.prompt-container:hover {
  color: red;
}
.thumbnail-item {
  display: inline-block;
  /* flex-direction: row; */
  width: 180px;
  margin: 2px;
}
</style>